import { render } from "./_MainCard.vue?vue&type=template&id=04b1c1fe"
import script from "./_MainCard.vue?vue&type=script&lang=js"
export * from "./_MainCard.vue?vue&type=script&lang=js"

import exportComponent from "/Users/pnz002/Project/dfy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__